<template>
  <div class="assinatura-conclusao-page">
    <Topo />
    <div class="row ml-1 mt-3">
      <br class="clear" />
      <h3>Vamos concluir sua assinatura!</h3>
  
      <!-- Plan -->
      <div class="col-md-12 mt-4">
        <h2 class="mb-3 ml-4"><span class="badge badge-secondary">1</span> Escolha seu Plano </h2>
        <div class="card float-left ml-4" style="width: 18rem;" v-for="plan in plans" :key="plan.id"
          v-bind:class="(plan.id  == subscription.planId)?'selecionado':''">
          <div class="card-body">
            <h5 class="card-title text-center">{{plan.name}}</h5>
            <h6 class="card-subtitle mb-2 text-muted text-center">{{plan.priceHolderFmt}} (por titular)</h6>
            <p class="card-text">
            <ul class="list-group list-group-flush">
              <li class="list-group-item text-center">{{plan.priceDependentFmt}} por dependente</li>
              <li class="list-group-item text-center" v-if="plan.hasfidelity">
                Fidelidade de 12 meses
              </li>
              <li class="list-group-item text-center" v-if="!plan.hasfidelity">
                Sem fidelidade
              </li>
              <li class="list-group-item text-center">Adesão {{plan.accessionFeeFmt}}</li>
              <li class="list-group-item text-center">
                <button class="btn btn-primary" @click="selectPlan(plan.id)">Quero Esse!</button>
              </li>
            </ul>
            </p>
          </div>
        </div>
      </div>
      <!-- Fim Plan -->
  
      <!-- Pay -->
      <div class="col-md-12 mt-4" v-show="subscription.planId != null">
        <h2 class="mb-3 ml-4"><span class="badge badge-secondary">2</span> Escolha a forma de
          pagamento<!-- e o vencimento--></h2>
        <form class="ml-3 mt-3 mr-3 mb-3">
          <select class="form-control" v-model="subscription.paymentType">
            <option value="CREDIT_CARD">Cartão de Crédito</option>
            <!-- <option value="DEBIT_CARD">Cartão de Débito</option> -->
          </select>
        </form>
        <!--
                <form class="ml-3 mt-3 mr-3 mb-3">
                  <select class="form-control" v-model="subscription.dayForPayment">
                      <option value="5" selected>Vencimento todo Dia 5</option>
                      <option value="10">Vencimento todo Dia 10</option>
                      <option value="15">Vencimento todo Dia 15</option>
                      <option value="20">Vencimento todo Dia 20</option>
                      <option value="25">Vencimento todo Dia 25</option>
                  </select>
                </form>   
                -->
      </div>
  
      <!-- Cartao de Credito -->
      <div class="col-md-12 mt-1"
        v-show="subscription.paymentType == 'CREDIT_CARD' || subscription.paymentType == 'DEBIT_CARD'">
        <h4 class="mb-3 ml-4">Dados do Cartão de Crédito </h4>
  
        <div>
  
          <h6 class="mb-3 ml-4"><small>Obs.: O uso de Cartões Virtuais implicam na atualização mensal dos dados do cartão
              no Sistema, ou seja, a recorrência de cobrança não funciona com Cartão Virtual.</small></h6>
  
        </div>
  
  
        <form class="ml-3 mt-1 mr-3 mb-3" style="width: 250px;">
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="far fa-credit-card"></i></span>
            </div>
            <select class="form-control" v-model="subscription.creditCard.brand">
              <option value="VISA">Visa</option>
              <option value="MASTERCARD">Mastercard</option>
              <option value="ELO">Elo</option>
              <option value="AMEX">American</option>
              <option value="HIPERCARD">Hipercard</option>
              <option value="OUTROS">Outros</option>
            </select>
          </div>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="far fa-credit-card"></i></span>
            </div>
            <input type="text" class="form-control mb-2" v-model="subscription.creditCard.number"
              placeholder="Número do Cartão" v-mask="['####.####.####.####']" />
          </div>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
            </div>
            <input type="text" class="form-control mb-2" v-model="subscription.creditCard.validate"
              placeholder="Vencimento Mês/Ano" v-mask="['##/####']" />
          </div>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-key"></i></span>
            </div>
            <input type="text" class="form-control mb-2" v-model="subscription.creditCard.securityCode"
              placeholder="Código de Segurança" v-mask="['####']" />
          </div>
          <input type="text" class="form-control" v-model="subscription.creditCard.name"
            placeholder="Nome como está no cartão" />
        </form>
      </div>
      <!--Fim Pay Plan -->
  
      <!-- Responsável Financeiro -->
      <div class="col-md-12 mt-3" v-show="subscription.paymentType != null">
        <h2 class="mb-3 ml-4"><span class="badge badge-secondary">3</span> Responsável Financeiro </h2>
        <form class="ml-3 mt-1 mr-3 mb-3">
          <div class="row">
            <div class="col ml-3 mt-3">
              <input id="respFinanceiroNao" v-model="subscription.holderOnlyResponsibleFinance" value="false"
                name="respFinanceiro" type="radio" aria-label="Eu vou usufruir dos serviços da assinatura.">
              <label for="respFinanceiroNao">
                &nbsp; Eu vou usufruir dos serviços dessa assinatura.
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col ml-3 mt-3">
              <input id="respFinanceiroSim" v-model="subscription.holderOnlyResponsibleFinance" value="true"
                name="respFinanceiro" type="radio"
                aria-label="Eu <strong>N?O</strong> vou usufruir. Sou um Responsável Financeiro dos meus dependentes.">
              <label for="respFinanceiroSim">
                &nbsp; Eu <B>NÃO</B> irei usufruir. Sou um <b>Responsável Financeiro</b> dos meus dependentes.<br />
              </label><br />
              <small>(Essa opção só será gerada cobrança para os dependentes)</small>
            </div>
          </div>
        </form>
      </div>
      <!-- Responsável Financeiro -->
  
      <!-- Dependents -->
      <div class="col-md-12 mt-3" v-show="subscription.paymentType != null">
        <h2 class="mb-3 ml-4"><span class="badge badge-secondary">4</span> Dependentes </h2>
        <button type="button" class="btn btn-primary ml-4 mb-4" @click="openModalDependent">Adicionar dependente</button>
        <ul class="list-group list-group-flush">
          <li class="list-group-item" v-for="(dep, index) in subscription.dependents" :key="dep.cpf">
            {{dep.name}}
            <button type="button" class="btn btn-light ml-2"
              @click="subscription.dependents.splice(index, 1)">Excluir</button>
          </li>
        </ul>
      </div>
      <!-- Dependents -->
  
      <!-- 
              <div class="col-md-12 mt-3" v-show="subscription.paymentType != null">
                <h2 class="mb-3 ml-4"><span class="badge badge-secondary">5</span> Pets </h2>
               <button type="button" class="btn btn-primary ml-4 mb-4" @click="openModalPet">Adicionar pet</button>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item" v-for="(pet, index) in subscription.pets" :key="pet.description">
                    {{pet.quantity}} - {{pet.description}}
                    <button type="button" class="btn btn-light ml-2" @click="subscription.pets.splice(index, 1)">Excluir</button>
                  </li>
                </ul>
              </div>
             -->
  
      <!-- Holder -->
      <div class="col-md-12 mt-3" v-show="subscription.paymentType != null">
        <h2 class="mb-3 ml-4"><span class="badge badge-secondary">5</span> Complete seu dados </h2>
        <form class="ml-3 mt-1 mr-3 mb-3" style="width: 350px;">
          <input type="text" class="form-control mb-2" @change="verificarCamposNaoPreenchidos"
            v-model="subscription.holder.zipcode" placeholder="CEP" v-mask="['#####-###']" @blur="validateZipcode" />
          <input type="text" class="form-control mb-2" @change="verificarCamposNaoPreenchidos"
            v-model="subscription.holder.address" placeholder="Endereço" maxlength="60" />
          <input type="text" class="form-control mb-2" @change="verificarCamposNaoPreenchidos"
            v-model="subscription.holder.number" placeholder="Número" v-mask="['#####']" />
          <input type="text" class="form-control mb-2" @change="verificarCamposNaoPreenchidos"
            v-model="subscription.holder.uf" placeholder="UF" maxlength="2" />
          <input type="text" class="form-control mb-2" @change="verificarCamposNaoPreenchidos"
            v-model="subscription.holder.city" placeholder="Cidade" maxlength="50" />
          <input type="text" class="form-control mb-2" @change="verificarCamposNaoPreenchidos"
            v-model="subscription.holder.neighborhood" placeholder="Bairro" maxlength="50" />
          <input type="text" class="form-control mb-2" @change="verificarCamposNaoPreenchidos"
            v-model="subscription.holder.cellPhone" placeholder="Telefone Celular" v-mask="['(##)#####-####']" />
          <input type="text" class="form-control mb-2" v-model="subscription.holder.homePhone"
            placeholder="Telefone Residencial" v-mask="['(##)####-####','(##)#####-####']" />
          <input type="text" class="form-control mb-2" @change="verificarCamposNaoPreenchidos"
            v-model="subscription.holder.dateOfBirth" placeholder="Data de Nascimento" v-mask="['##/##/####']" />
          <select class="form-control mb-2" v-model="subscription.holder.sex">
            <option value="MALE">Masculino</option>
            <option value="FEMALE">Feminino</option>
            <option value="NI">Não informado</option>
          </select>
        </form>
      </div>
      <!-- Fim Holder -->
  
      <div class="col-md-12 mt-3 ml-4" v-show="subscription.paymentType != null">
        <input id="chkAcordo" type="checkbox" v-model="acordo" class="btn btn-primary" :disabled="camposNaoPreenchidos" />
        Li e concordo com os <button type="button" class="btn btn-link mb-1 ml-n2" :disabled="camposNaoPreenchidos"
          @click="showContract">termos do contrato</button>
      </div>
      <div class="col-md-12 mt-3 mb-5 ml-3" v-show="subscription.paymentType != null">
        <button id="btnConcluiAssinatura" type="button" class="btn btn-primary" @click="createSubscription"
          :disabled="camposNaoPreenchidos || !acordo">Concluir Assinatura</button>
      </div>
    </div>
  
    <modal name="modal-contrato" width="75%" height="500px">
      <div>
        <h4 class="text-center mb-2">Termos do Contrato</h4>
        <div style="text-align: -moz-center;">
          <div style="width: 90%; overflow-x: auto; height: 350px">
            <div v-html="conteudoContrato"></div>
          </div>
          <div class="mt-2" v-html="conteudoAssinatura"></div>
        </div>
        <br class="clear" />
        <div class="col-md-12 text-center mb-1">
          <button type="button" class="btn btn-primary" @click="closeModalContrato">Ok</button>
        </div>
      </div>
    </modal>
  
    <!-- Modais -->
    <modal name="modal-dependent" width="300px" height="auto">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center mb-2">Meu Dependente</h4>
        <form>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-user"></i></span>
            </div>
            <input type="text" class="form-control mb-2" v-model="dependent.name" placeholder="Nome completo"
              maxlength="50" />
          </div>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-ticket-alt"></i></span>
            </div>
            <input type="text" class="form-control mb-2" v-model="dependent.cpf" placeholder="CPF"
              v-mask="['###.###.###-##']" />
          </div>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
            </div>
            <input type="text" class="form-control mb-1" v-model="dependent.dateOfBirth" placeholder="Data de Nascimento"
              v-mask="['##/##/####']" />
          </div>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-at"></i></span>
            </div>
            <input type="text" class="form-control mb-1" v-model="dependent.email" placeholder="E-mail" maxlength="80" />
          </div>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-phone"></i></span>
            </div>
            <input type="text" class="form-control mb-1" v-model="dependent.phone" placeholder="Telefone"
              v-mask="['(##)#####-####']" maxlength="14" />
          </div>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-restroom"></i></span>
            </div>
            <select class="form-control mb-1" v-model="dependent.sex">
              <option value="MALE">Masculino</option>
              <option value="FEMALE">Feminino</option>
              <option value="NI">Não informado</option>
            </select>
          </div>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-user-friends"></i></span>
            </div>
            <select class="form-control mb-1" v-model="dependent.kinship">
              <option value="">Parentesco</option>
              <option value="Pai">Pai</option>
              <option value="Mãe">Mãe</option>
              <option value="Avô">Avô</option>
              <option value="Avó">Avó</option>
              <option value="Filho/Filha">Filho/Filha</option>
              <option value="Tio/Tia">Tio/Tia</option>
              <option value="Irmão/Irmã">Irmão/Irmã</option>
              <option value="Sobrinho">Sobrinho</option>
              <option value="Neto">Neto</option>
              <option value="O">Outros</option>
            </select>
            <div class="input-group" v-if="dependent.kinship=='O'">
              <div class="input-group-prepend mb-2">
                <span class="input-group-text"><i class="fas fa-user-plus"></i></span>
              </div>
              <input type="text" class="form-control mb-1" v-model="dependent.kinshipAlt" placeholder="Outros"
                maxlength="30" />
            </div>
          </div>
        </form>
        <br class="clear" />
        <div class="col-md-12 text-center mt-1">
          <button type="button" class="btn btn-primary" @click="addDependent">Confirmar</button>
          <button type="button" class="btn btn-secundary ml-4" @click="closeModalDependent">Desistir</button>
        </div>
      </form>
    </modal>
  
    <!-- Modais -->
    <modal name="modal-pet" width="300px" height="auto">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center mb-2">Meu Pet</h4>
        <form>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-paw"></i></span>
            </div>
            <select class="form-control mb-1" placeholder="Tipo de Pet" v-model="pet.description">
              <option v-for="option in typesPet" :key="option.description" :label="option.description"
                :value="option.description" />
            </select>
          </div>
          <div class="input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-sliders-h"></i></span>
            </div>
            <input type="text" class="form-control mb-2" v-model="pet.quantity" placeholder="Quantidade"
              v-mask="['###']" />
          </div>
        </form>
        <br class="clear" />
        <div class="col-md-12 text-center mt-1">
          <button type="button" class="btn btn-primary" @click="addPet">Confirmar</button>
          <button type="button" class="btn btn-secundary ml-4" @click="closeModalPet">Desistir</button>
        </div>
      </form>
    </modal>
  
  </div>
</template>

<script>
import Topo from '@/components/Topo.vue'
import Vue from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: "6LeDu_IpAAAAAGawg8nR3SFA_ZYpSwsC71Ub1f_U" });

const optionsAlert = { title: 'Mensagem', size: 'sm' }

export default {
  name: 'assinaturaConclusao',
  props: ["broker", "pointsale"],
  components: {
    Topo
  },
  created() {
    this.loadPlans()
  },
  data() {
    return {
      acordo: false,
      camposNaoPreenchidos: true,
      conteudoContrato: "",
      conteudoAssinatura: "",
      beginSaveProcess: false,
      plans: [],
      dependent: {
        name: null,
        cpf: null,
        dateOfBirth: null,
        email: null,
        phone: null,
        sex: 'MALE',
        kinship: '',
        kinshipAlt: "",
      },
      subscription: {
        brokerId: this.broker,
        companyId: (this.pointsale) ? this.pointsale : 1, //fixo 1 site
        holderOnlyResponsibleFinance: false,
        planId: null,
        paymentType: null,
        //dayForPayment: 5,
        dependents: [],
        pets: [],
        creditCard: {
          name: null,
          number: null,
          validate: null,
          securityCode: null,
          brand: null
        },
        holder: {
          cellPhone: null,
          homePhone: null,
          dateOfBirth: null,
          zipcode: null,
          address: null,
          number: null,
          uf: "RJ",
          city: null,
          neighborhood: null,
          sex: 'MALE',
          name: '',
          cpfCnpj: ''
        },
        acceptedContract: false
      },
      typesPet: [],
      pet: {
        quantity: null,
        description: null
      },
    }
  },
  methods: {
    loadPlans() {
      this.$clubApi.get('/plan/list/avaliable/site')
        .then((response) => {
          this.plans = response.data.object
        }).catch(() => {
          this.$dialogs.alert('Erro ao carregar planos disponíveis.', optionsAlert)
        })
    },
    createSubscription() {

      document.getElementById("btnConcluiAssinatura").disabled = true;
      document.getElementById("chkAcordo").disabled = true;
      this.beginSaveProcess = true
      this.subscription.brokerId = this.broker;
      this.subscription.companyId = (this.pointsale) ? this.pointsale : 1;
      this.subscription.acceptedContract = true

      let data = {};

      this.$recaptcha("login").then((token) => {
        data["g-recaptcha-response"] = token;

        this.$clubApi.put(
          '/subscription', this.subscription,
          data,
          {
            headers: {
              Accept: "application/json",
            },
          }
        )
          .then(() => {
            location.href = '/home'
          }).catch((error) => {
            document.getElementById("btnConcluiAssinatura").disabled = false;
            document.getElementById("chkAcordo").disabled = false;
            this.$dialogs.alert(error.response.data.msg, optionsAlert)
          }).finally(() => {
            this.beginSaveProcess = false
            NProgress.done()
          })
      });
    },
    showContract() {
      this.subscription.holder.name = localStorage.getItem("name");
      this.subscription.holder.cpfCnpj = localStorage.getItem("cpf");
      this.$clubApi.post('/subscription/generate/contract-file/new', this.subscription)
        .then((response) => {
          this.$modal.show('modal-contrato')
          this.conteudoContrato = response.data;
          this.conteudoAssinatura = "Esse contrato foi assinado virtualmente pelo Sr(a). " + this.subscription.holder.name + " em " + this.obterDataHora();
        }).catch((error) => {
          console.log(error);
          this.$dialogs.alert(error.response.data.msg, optionsAlert)
        }).finally(() => {
          NProgress.done()
        })
    },
    selectPlan(id) {
      this.subscription.planId = id
    },
    closeModalDependent() {
      this.$modal.hide('modal-dependent')
    },
    openModalDependent() {
      this.$modal.show('modal-dependent')
    },
    openModalPet() {
      this.pet = {
        quantity: null,
        description: null
      };
      this.loadPets();
      this.$modal.show('modal-pet')
    },
    closeModalPet() {
      this.$modal.hide('modal-pet')
    },
    closeModalContrato() {
      this.$modal.hide('modal-contrato')
    },
    addDependent() {
      let kinshipPreenchido = this.dependent.kinship;
      if (this.dependent.kinship === "O") {
        kinshipPreenchido = this.dependent.kinshipAlt;
      }
      this.subscription.dependents.push({
        name: this.dependent.name,
        cpf: this.dependent.cpf,
        dateOfBirth: this.dependent.dateOfBirth,
        email: this.dependent.email,
        phone: this.dependent.phone,
        sex: this.dependent.sex,
        kinship: kinshipPreenchido
      })
      this.dependent = {
        name: '',
        cpf: '',
        dateOfBirth: '',
        email: '',
        phone: '',
        sex: 'MALE',
        kinship: '',
        kinshipAlt: "",
      }
      this.closeModalDependent()
    },
    validateZipcode() {
      var zipcode = this.subscription.holder.zipcode.replace("-", "")

      if (zipcode == "") {
        this.subscription.holder.zipcode = "";
        this.subscription.holder.address = "";
        this.subscription.holder.number = "";
        this.subscription.holder.uf = "";
        this.subscription.holder.city = "";
        this.subscription.holder.neighborhood = "";
      }
      else {
        this.$clubApi.get('/utils/zipcode/' + zipcode)

          .then((response) => {
            this.subscription.holder.address = response.data.object.logradouro;
            this.subscription.holder.uf = response.data.object.uf;
            this.subscription.holder.city = response.data.object.localidade;
            this.subscription.holder.neighborhood = response.data.object.bairro;
          }).catch((error) => {
            this.subscription.holder.zipcode = "";
            this.subscription.holder.address = "";
            this.subscription.holder.number = "";
            this.subscription.holder.uf = "";
            this.subscription.holder.city = "";
            this.subscription.holder.neighborhood = "";
            this.$dialogs.alert(error.response.data.msg, optionsAlert)
          }).finally(() => {
            this.verificarCamposNaoPreenchidos();
            NProgress.done()
          })
      }
    },
    verificarCamposNaoPreenchidos() {
      let naoPreenchidos =
        (this.subscription.holder.zipcode == null)
        || (this.subscription.holder.address == null)
        || (this.subscription.holder.number == null)
        || (this.subscription.holder.city == null)
        || (this.subscription.holder.neighborhood == null)
        || (this.subscription.holder.uf == null)
        || (this.subscription.holder.cellPhone == null)
        || (this.subscription.holder.dateOfBirth == null)
        || (this.subscription.holder.zipcode == "")
        || (this.subscription.holder.address == "")
        || (this.subscription.holder.number == "")
        || (this.subscription.holder.city == "")
        || (this.subscription.holder.neighborhood == "")
        || (this.subscription.holder.uf == "")
        || (this.subscription.holder.cellPhone == "")
        || (this.subscription.holder.dateOfBirth == "");
      return this.camposNaoPreenchidos = naoPreenchidos;
    },
    obterDataHora() {
      let dataAtual = new Date();
      let dia = (dataAtual.getDate() < 10) ? "0" + dataAtual.getDate() : dataAtual.getDate()
      let mes = (dataAtual.getMonth() + 1 < 10) ? "0" + (dataAtual.getMonth() + 1) : dataAtual.getMonth() + 1
      let hora = (dataAtual.getHours() < 10) ? "0" + dataAtual.getHours() : dataAtual.getHours()
      let minuto = (dataAtual.getMinutes() < 10) ? "0" + dataAtual.getMinutes() : dataAtual.getMinutes()
      let segundo = (dataAtual.getSeconds() < 10) ? "0" + dataAtual.getSeconds() : dataAtual.getSeconds()
      return dia + "/" + mes + "/" + dataAtual.getFullYear() + " " + hora + ":" + minuto + ":" + segundo;
    },
    loadPets() {
      this.$clubApi.get("/subscription/pet/list")
        .then(response => {
          this.typesPet = response.data.object;
        }).catch(error => {
          this.$dialogs.alert(error.response.data.msg, optionsAlert);
        }).finally(() => {
          NProgress.done();
        });
    },
    addPet() {
      let tamFiltro = this.subscription.pets.filter(pet => {
        return (pet.description === this.pet.description);
      }).length;

      this.closeModalPet();
      if (tamFiltro > 0) {
        this.$dialogs.alert('Já existe ' + this.pet.description + ' na lista.', optionsAlert);
      } else {
        this.subscription.pets.push({
          quantity: this.pet.quantity,
          description: this.pet.description
        });
        this.pet = {
          quantity: null,
          description: null
        };
      }
    }
  }
}
</script>

<style scoped>
.selecionado {
  border: solid 2px transparent;
  border-color: #2C4759;
}
</style>
